import { FC } from 'react';
import RcSlider, { SliderProps } from 'rc-slider';
import 'rc-slider/assets/index.css';
import styled from 'styled-components';
import { COLORS } from '@app/constants';
import { BreakpointsEnum } from '@app/types';

interface Props extends SliderProps {
  className?: string;
}

const Slider: FC<Props> = ({ className, ...props }) => {
  return (
    <Root className={className}>
      <RcSlider {...props} />
    </Root>
  );
};

const Root = styled.div`
  .rc-slider {
    height: 2px;
    padding: 0;
  }
  .rc-slider-rail {
    height: 2px;
    background-color: ${COLORS.grayscale100};
  }
  .rc-slider-track {
    background-color: ${COLORS.primary200};
    top: -1px;
  }
  .rc-slider-handle {
    width: 10px;
    height: 10px;
    background-color: ${COLORS.primary300};
    border: none;
    border-width: 4px;
    opacity: 1;
    margin-top: -5px;
    &:hover,
    &:active,
    &:focus {
      box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.6);
    }
  }
  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
    box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.6);
  }

  @media (max-width: ${BreakpointsEnum.sm}px) {
    .rc-slider-handle {
      width: 14px;
      height: 14px;
      margin-top: -7px;
      &::before {
        content: '';
        width: 25px;
        height: 25px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
`;

export default Slider;
